import { useApolloClient } from '@apollo/client/react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { type SidebarChildLinkConfig } from '@app/components/sidebar/sidebarLinkConfig';
import {
  SIDEBAR_CHILD_ICON_SIZE,
  childItemSx,
  isPathActive,
} from '@app/components/sidebar/sidebarNavStyles';

type Props = {
  link: SidebarChildLinkConfig;
  variant: 'accordion' | 'popover';
  onNavigate?: () => void;
};

export const SidebarChildLink = ({ link, variant, onNavigate }: Props) => {
  const client = useApolloClient();
  const location = useLocation();
  const active = isPathActive(link.path, location.pathname);
  const { prefetch, icon: Icon } = link;

  return (
    <ListItemButton
      component={Link}
      to={link.path}
      selected={active}
      dense={true}
      disableRipple={true}
      onClick={onNavigate}
      onMouseEnter={prefetch ? () => client.query(prefetch) : undefined}
      sx={childItemSx(variant)}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: 1.5,
          justifyContent: 'center',
          color: 'inherit',
        }}
      >
        <Icon size={SIDEBAR_CHILD_ICON_SIZE} />
      </ListItemIcon>
      <ListItemText
        primary={link.label}
        slotProps={{ primary: { sx: { fontSize: 14 }, noWrap: true } }}
      />
    </ListItemButton>
  );
};
